import { render } from "./CANDIDATE_VAL_NEW.vue?vue&type=template&id=7afb0db2"
import script from "./CANDIDATE_VAL_NEW.vue?vue&type=script&lang=js"
export * from "./CANDIDATE_VAL_NEW.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__